import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt'
import { faShareAlt } from '@fortawesome/pro-regular-svg-icons/faShareAlt'
import { faCommentAltLines } from '@fortawesome/pro-regular-svg-icons/faCommentAltLines'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faLaugh } from '@fortawesome/pro-regular-svg-icons/faLaugh'
import { faCookieBite } from '@fortawesome/pro-regular-svg-icons/faCookieBite'
import { faReply } from '@fortawesome/pro-regular-svg-icons/faReply'
import { faSignalStream } from '@fortawesome/pro-regular-svg-icons/faSignalStream'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft'

export default [
  faCalendarAlt,
  faShareAlt,
  faCommentAltLines,
  faArrowRight,
  faTimes,
  faLaugh,
  faCookieBite,
  faReply,
  faSignalStream,
  faAngleDown,
  faArrowLeft
]
